export class ActionQueue {
	private queue: Array<{
		action: () => Promise<unknown>;
		resolve: (value: any) => void;
		reject: (error: unknown) => void;
	}> = [];
	private isProcessing = false;

	enqueue<T>(action: () => Promise<T>): Promise<T> {
		return new Promise<T>((resolve, reject) => {
			this.queue.push({ action, resolve, reject });
			// No necesito hacer el await de process porque
			// realmente me enteraré de que se ha ejecutado mi
			// acción por el resolve que lleva asociado. Así
			// evito tener que controlar el caso en que ya se
			// estuvieran procesando acciones y el await haga
			// un return temprano.
			void this.process();
		});
	}

	private async process(): Promise<void> {
		if (this.isProcessing) return;

		this.isProcessing = true;

		while (this.queue.length > 0) {
			const { action, resolve, reject } = this.queue.shift()!;
			try {
				const result = await action();
				resolve(result);
			} catch (error) {
				reject(error);
			}
		}

		this.isProcessing = false;
	}

	clear(): void {
		this.queue = [];
	}

	isIdle(): boolean {
		return !this.isProcessing && this.queue.length === 0;
	}

	waitUntilIsIdle(): Promise<void> {
		return new Promise(resolve => {
			const interval = setInterval(() => {
				if (this.isIdle()) {
					clearInterval(interval);
					resolve();
				}
			}, 5);
		});
	}
}

